module.exports = __webpack_public_path__ + "static/img/css.82e64dfd.svg";